<template>
  <v-container grid-list-xs>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <h1 class="display-1">Billing Details</h1>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5">
      <v-flex xs12 md8 offset-md2>
        <v-form
          @submit.prevent="submit()"
          v-model="valid"
          ref="form"
          lazy-validation
          class="mb-3 pb-5"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <h2 class="headline mb-2">Total Due Today</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="plan-details">
            <v-flex xs9 class="pr-3 bg--stripe">
              <div class="product--desc">
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6>
                    <span class="title" v-html="planName"></span>
                  </v-flex>
                  <v-flex xs12 sm6 class="text-sm-right">
                    <!-- <div class="change-plan">(<router-link to="select-plan">change</router-link>)</div> -->
                    <v-btn
                      :to="{ name: 'select-plan' }"
                      small
                      color="accent-light elevation-0 accent--text ml-0"
                    >Change</v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs3 class="text-xs-right align-center d-flex bg--stripe pr-3">
              <span class="product--line-item-price">{{ planPrice | currency }}</span>
            </v-flex>
            <v-flex xs9 class="pr-3 alt--row bg--stripe">
              <div class="product--desc">
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6>
                    <span class="title">{{ planPhone | friendlyDisplayPhone }}</span>
                  </v-flex>
                  <v-flex xs12 sm6 class="text-sm-right align-center">
                    <v-btn
                      :to="{ name: 'select-number' }"
                      small
                      color="accent-light elevation-0 accent--text ml-0"
                    >Change</v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs3 class="text-xs-right align-center d-flex alt--row bg--stripe pr-3">
              <div class="product--line-item-price">{{ 0.00 | currency }}</div>
            </v-flex>
            <!-- plan details -->
            <!-- <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="details--whats-included">
                    <h2 class="title mb-2 uppercase accent--text">Included in your plan:</h2>
                    <div class="plan--desc" v-html="planDescription"></div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>-->
            <v-flex xs12>
              <v-layout row wrap class="plan--costs pa-3">
                <v-flex xs9 class="text-sm-right pr-3">
                  <span>Sub-total</span>
                </v-flex>
                <v-flex xs3 class="text-xs-right">{{ subtotal | currency }}</v-flex>
                <v-flex xs9 class="text-sm-right pr-3">
                  <v-divider dark class="mb-1 mt-1 ml-3"></v-divider>
                  <span>Taxes</span>
                </v-flex>
                <v-flex xs3 class="text-xs-right">
                  <v-divider class="mb-1 mt-1"></v-divider>
                  {{ taxes | currency }}
                </v-flex>
                <v-flex xs9 class="text-sm-right pr-3">
                  <v-divider dark class="mb-1 mt-1 ml-3"></v-divider>
                  <div class="price--total pt-2">Total</div>
                </v-flex>
                <v-flex xs3 class="text-xs-right">
                  <v-divider class="mb-1 mt-1"></v-divider>
                  <div class="price--total pt-2">{{ totalPrice | currency }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="mt-4">Payment Details</h3>
            </v-flex>
            <v-flex xs12>
              <v-alert
                type="warning"
                :value="failedAVS"
                icon="new_releases"
                transition="fade-transition"
              >Please confirm your credit card information and billing address below.</v-alert>
            </v-flex>
            <v-layout
              row
              wrap
              pa-1
              class="billing-details"
              :class="{ 'billing-details-warning': failedAVS }"
            >
              <v-flex xs12 sm6 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                <v-text-field
                  label="Cardholder Name"
                  :rules="[rules.required]"
                  v-model="cc.name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Card Number"
                  v-model="cc.number"
                  :mask="masks.creditCard"
                  :rules="[rules.required, rules.validCreditCard, rules.validCreditCardType]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 class="pr-2">
                <v-text-field
                  label="Expiry Month"
                  hint="MM"
                  persistent-hint
                  :mask="masks.expiryMonth"
                  :rules="[rules.required]"
                  v-model="cc.expiryMonth"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                <v-text-field
                  label="Expiry Year"
                  hint="YYYY"
                  persistent-hint
                  :mask="masks.expiryYear"
                  v-model="cc.expiryYear"
                  :rules="[rules.expiryYear, rules.required]"
                  :validate-on-blur="true"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 md3>
                <v-text-field
                  label="CVV"
                  v-model="cc.cvc"
                  :mask="masks.cvc"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm1 md3>
                <v-tooltip top>
                  <v-btn icon slot="activator">
                    <v-icon color="accent">help</v-icon>
                  </v-btn>
                  <span>3 or 4 digit security code located on the back of the card</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout row wrap v-if="failedAVS">
            <v-flex xs12>
              <v-layout
                row
                wrap
                pa-1
                class="billing-details"
                :class="{ 'billing-details-warning': failedAVS }"
              >
                <v-flex xs12 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                  <v-text-field
                    label="Address"
                    v-model="cc.billingAddress1"
                    :rules="[rules.required, rules.streetAddress]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                  <v-text-field label="Unit/Apartment #" v-model="cc.billingAddress2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                  <v-text-field v-model="cc.billingAddress3" label="PO Box"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Postal Code"
                    hint="Format: A1A A1A"
                    persistent-hint
                    v-model="cc.billingAddressPostalCode"
                    :rules="[rules.required, rules.postalCode]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
                  <v-text-field
                    label="City"
                    v-model="cc.billingAddressCity"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Select a Province"
                    v-model="cc.billingAddressProvince"
                    :items="provinces"
                    :rules="[rules.required]"
                    required
                    bottom
                    item-text="name"
                    item-value="val"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    label="Save this as my billing information"
                    v-model="updateBillingDetails"
                    class="nowrap"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-baseline pa-1>
            <v-flex xs12>
              <v-checkbox
                label="Automatically topup my account every 30 days"
                v-model="topup"
                class="nowrap"
              ></v-checkbox>
              <v-checkbox v-model="accepted" class="nowrap" required :rules="[rules.required]">
                <template slot="label">
                  I agree to the
                  <a @click.stop="dialog = true">terms of service</a>
                </template>
              </v-checkbox>
              <v-dialog v-model="dialog" scrollable max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Terms of Service</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="conditions" style="height: 300px;">
                    <h1>ICE WIRELESS TERMS &amp; CONDITIONS</h1>
                    <p>The current Terms of Service apply to each and all Ice Wireless subscribers. The following words and expressions in this part, when they appear in this Agreement, or within any related document and unless the context or the text clearly indicates otherwise have the following meaning:</p>
                    <ul>
                      <li>Customer, you, your – refers to the person or organization subscribed to the Ice Wireless Services;</li>
                      <li>Ice Wireless, we, us, our – refers to Ice Wireless Inc.</li>
                      <li>Service(s) – refers to telecommunications Services provided by Ice Wireless.</li>
                    </ul>
                    <br />
                    <b>1.&nbsp;&nbsp;&nbsp;&nbsp;Term</b>
                    <p>Services are offered on a monthly basis or subject to a commitment term as agreed by entering into a Service Agreement. Subsequent terms of the Agreement will be renewed automatically on a monthly basis at the existing rates unless you provide us with written notice of non-renewal. If you agreed to a commitment of 12 months or longer, we will notify you with 90 days before the expiry of your Service Agreement.</p>
                    <br />
                    <b>2.&nbsp;&nbsp;&nbsp;&nbsp;Ice Tab</b>
                    <p>Ice Tab is available to Customers electing a Service Plan with Data allowance. With the Tab program we are allowing you to pay a portion or the entire value of a device in equal monthly amounts over a determined period, as per the purchase option you select. You may remit payments at your convenience for any multiple of your monthly tab charge to reduce or clear the pending Tab balance. You are permitted one purchase per Line. Additional devices may be purchased once the pending Tab balance has been cleared in full.</p>
                    <br />
                    <b>3.&nbsp;&nbsp;&nbsp;&nbsp;Reasonable Use</b>
                    <p>You may use the Services only for your own lawful purposes. We may from time to time set out use policies and guidelines for the use of Services. Services cannot be used for transmitting or receiving any illegal, harmful, threatening, abusive, harassing, defamatory, obscene, sexually explicit, profane, racially or ethnically disparaging remarks or otherwise objectionable material of any kind. This includes, but is not limited to, any material that encourages conduct that would constitute a criminal offence, give rise to a civil liability, or otherwise violate any applicable local, state, provincial, national or international law.</p>
                    <p>We have built our network around sustaining high-speed data services; however, in times of network congestion, to ensure the best service experience for the majority of our customers, we reserve the right to prioritize the allocation of network resources to customers whose usage is below 10GB in a given month for satellite-served home network locations, below 20GB for non-satellite-served home network locations, or below 4GB while roaming outside the Ice Wireless home network. There may be other factors such as weather, signal strength, device capabilities, technical limitations, or outages that could affect your data speed.</p>
                    <p>You must note that the service is provided for regular commercial and/or residential use only and we reserve the right to suspend or terminate the service if you are in breach of any use policies.</p>
                    <br />
                    <b>4.&nbsp;&nbsp;&nbsp;&nbsp;Home Phone &amp; Internet Services</b>
                    <p>Home Phone &amp; Internet Services facilitate the use of traditional wireless SIM Cards via cordless devices. You understand that non-purchased devices received from Ice Wireless for the use of Home Phone or Internet Services remain the property of Ice Wireless for the duration of the Service.</p>
                    <p>Loaner devices may be available to customers electing a month-to-month Service Plan. You must return the loaned device within 30 days of your Service termination in working condition, undamaged, and including the original packaging and accessories received at time of shipment or activation. Failure to return a loaned device will result into charging your account with the purchase value of the device.</p>
                    <br />
                    <b>5.&nbsp;&nbsp;&nbsp;&nbsp;Billing</b>
                    <p>You will receive an invoice within the first week of each month for the current month recurring charges and the usage charges incurred in the previous billing cycle. Invoices are due on the fifteenth day of the same month. Recurring charges are pro-rated from the service activation date until the end of the month. All rates are tax exclusive and any applicable tax will be indicated on the Ice Wireless invoice. If you are exempted from payment of such taxes then you must provide an original government-issued certificate attesting to tax-exempt status.</p>
                    <p>A late payment charge applies when payment has not been received fifteen days after the invoice date. This charge is a monthly compound rate of 1.5%.</p>
                    <p>Billing disputes must be reported to Customer Care/Billing Department (customercare@icewireless.ca/ Toll Free # 1855-474-7423) within 15 days of the invoice date or any such dispute may be deemed waived. It is your responsibility to verify the content of the invoices and report any errors or inconsistencies regarding the recurring and non-recurring charges billed therein. Recurring charges billed erroneously or over billed, will be credited the excess incurred within the previous 90 days of service. Non-recurring charges, including but not limited to usage charges, billed erroneously or over billed, will be credited the excess incurred, provided that a dispute has been received within 15 days of the invoice date.</p>
                    <br />
                    <b>6.&nbsp;&nbsp;&nbsp;&nbsp;Payments</b>
                    <p>Ice Wireless accepts the following payment methods:</p>
                    <ul>
                      <li>Credit card withdrawals</li>
                      <li>Online/Telephone Banking</li>
                      <li>Checks</li>
                      <li>Pre-authorized Payments. Your use of Services, after having submitted credit card information with the express request to be used for pre-authorized payments, validates Ice Wireless’s processing of the provided information for the due charges. You must notify us of any changes in your payment information.</li>
                    </ul>
                    <p>Ice Wireless may disconnect your Service if any charge for Services is attempted on your credit card and declined and/or in the case of any other non-payment of account charges. In the case of termination of Service for non-payment, you will be fully liable to Ice Wireless for all charges accrued to date of termination, as well as for charges incurred by Ice Wireless owing to non-payment, such as (but not limited to) collection costs and attorney’s fees.</p>
                    <br />
                    <b>7.&nbsp;&nbsp;&nbsp;&nbsp;Credit Verification</b>
                    <p>You understand that the information provided to Ice Wireless in the sign-up process or thereafter may be used to determine your credit worthiness and assess your ability to meet the financial obligations under this Agreement. Not limited to the result of the credit verification, Ice Wireless may request a security deposit of the minimum $100 which stands as the primary condition for providing the services. We will provide reasonable justification of the reasons for requesting a security deposit and we will keep a record of those reasons for as long as the security deposit is maintained. The Security Deposit may be returned to you after a period of minimum twelve (12) months of positive payment history. You may opt for using such amount against the outstanding balance of your account. Certain restrictions may apply to credit limits, services and features extended to you based on the result of the credit verification.</p>
                    <p>Subject to service termination, it may take up to 30 days to process your security deposit refund. You will be refunded any such amount unused for final billing. The Security Deposit will earn interest based on 1% above the Bank of Canada’s target for the Overnight Rate in effect at the time of the return, calculated monthly.</p>
                    <p>Ice Wireless is using the major credit bureaus as its main source for collecting credit information and such inquiries will be visible on your credit report. You authorize Ice Wireless Inc. and its agents or assigns to:</p>
                    <ul>
                      <li>Request and obtain personal information on an ongoing basis from credit bureaus from previously collected credit history information;</li>
                      <li>Exchange personal information on an ongoing basis with credit bureaus in order to protect you, to ensure the completeness of the information and to maintain the integrity of the credit granting system;</li>
                      <li>Co-operate with local, provincial and national authorities in the investigation of unlawful or improper activities in order to you and Ice Wireless from fraudulent transactions;</li>
                      <li>Disclose personal information where necessary to protect you and Ice Wireless’s interests.</li>
                      <li>You agree that Ice Wireless may conduct a preauthorization on your credit card, in order to determine credit worthiness, which will imply blocking an amount at least equal to the first invoice. The amount will be released in 48 hours (Note: certain banks release the amount upon customer’s request).</li>
                    </ul>
                    <p>We reserve the right, in our sole and absolute discretion, to refuse Tab purchases should we deem that our credit approval criteria’s are not met.</p>
                    <br />
                    <b>8.&nbsp;&nbsp;&nbsp;&nbsp;Disconnection/Termination</b>
                    <p>If you are not satisfied with the Services, you may return your Ice Wireless device and terminate the Agreement and all Services at any time within 15 calendar days of the activation date (“Trial Period”). If you are a person with a disability, the Trial Period will be extended to 30 calendar days. Your termination of service during the Trial Period will exempt you from any recurring charges accrued and provided that your device meets the return conditions, you will not be charged an early termination fee. The device must be returned in like-new condition, including original manufacturer’s packaging, accessories and the purchase receipt. We reserve the right to charge you for any missing or damaged item. At our sole discretion, we may decline the return if your cumulated usage during the Trial Period exceeds fifty percent (50%) of your monthly usage allotment. Calling Ice Wireless does not count towards said usage limit.</p>
                    <p>The early termination fee may be the remaining outstanding balance on your device discount, where the discount is split in equal monthly amounts over the course of the Agreement and such discount decreases with each month fulfilled. If no device discount is available then the early termination fee will be the lesser of $50 or 10% of the minimum monthly fee for the number of months remained unfulfilled.</p>
                    <p>You may request termination of Service or the account by submitting a termination request to our Customer Care Team (customercare@icewireless.ca) or by calling our Support line at +1 (855) 474-7423. Termination will be effective with such date indicated by your request. Upon termination of service, you will continue to be liable for all charges incurred to date of termination, including but not limited to an early termination fee and the outstanding Tab balance, if any applicable per your Service Agreement.</p>
                    <p>We may disconnect or terminate your Service if:</p>
                    <ul>
                      <li>You fail to pay an account that has been past due for more than 14 days.</li>
                      <li>You fail to provide or maintain a reasonable security deposit or alternative when requested to do so.</li>
                      <li>You agreed to a deferred payment plan and you fail to comply with the terms.</li>
                      <li>You are in breach of the Agreement and Use policies.</li>
                      <li>We reasonably suspect or determine that your account or Services are subject to fraudulent, unlawful or improper usage or usage that adversely affects the network or other Customers.</li>
                      <li>You do not maintain Service usage within the prescribed credit limit or you are in breach of any limitations set out by us in any reasonable use policies.</li>
                    </ul>
                    <p>Unless action is necessary to protect the Ice Wireless network or we have reasonable suspicion of fraud activity under your account, we deem to provide you notice with at least 14 calendar days before disconnection. The notice will contain the reason for disconnection and the amount owing, the scheduled disconnection date, availability for a deferred payment plan and the contact information for the Finance and Legal Team. We will attempt to notify you at least 24 hours before the scheduled disconnection unless repeated attempts to contact you have failed. Disconnection may occur on weekdays between 8 a.m. and 9 p.m. or on weekends between 9 a.m. and 5 p.m., unless the weekday or weekend day precedes a statutory holiday, in which case disconnection will not occur after noon. The applicable time for disconnections is according to the time zone of your declared place of residence.</p>
                    <p>We may postpone your Service disconnection if a valid dispute is received before the scheduled disconnection date and we do not have reasonable grounds to believe that such dispute has been raised for the purpose of avoiding or delaying payment.</p>
                    <br />
                    <b>9.&nbsp;&nbsp;&nbsp;&nbsp;Prepaid</b>
                    <p>We will not send you an invoice for prepaid Services. You must keep a positive balance at all times with your prepaid account to enable use of the Services. To add funds (“Top Up”) you can either use prepaid vouchers or set-up your account for monthly “Top-Up” withdrawals. Prepaid funds are non-refundable.</p>
                    <p>Your prepaid Plan will automatically renew every thirty (30) days where sufficient funds are available in your account. Unused funds will be carried over; however, any included unused minutes, data or text messages will expire with the 30 days period. If you do not activate or renew a prepaid Plan and your account has unused funds, such funds usage will be subject to the standard outside prepaid Plan (“pay-per-use”) rates available at www.icewireless.ca.</p>
                    <p>You may Top Up your account at any time. The prepaid funds will remain valid for the time period specified at www.icewireless.ca and starting with the date and time of your Top Up (“Account Period”). Upon expiration of the Account Period you must Top Up within 7 calendar days to retain any unused prepaid funds. Your prepaid account will be permanently closed and your wireless number may be reassigned by Ice Wireless at its sole discretion if no Top Up is performed within 90 days of the Account Period expiration.</p>
                    <p>If your device is lost or stolen, we will suspend your account and cancel any automatic Top Up withdrawal once you provide us notice. Your unused prepaid funds will continue to be valid for the Account Period and you must continue to Top Up with at least 7 calendar days of the Account Period expiration to retain the funds.</p>
                    <br />
                    <b>10.&nbsp;&nbsp;&nbsp;&nbsp;Promotional Packages</b>
                    <p>On occasion, Ice Wireless may offer promotional packages (“Promotions”). By subscribing to a promotion you accept the terms and duration described in the promotional literature or on the website. For more information on specific promotions you may contact our Customer Care Team or reach out to one of the local stores.</p>
                    <br />
                    <b>11.&nbsp;&nbsp;&nbsp;&nbsp;Proprietary Rights</b>
                    <p>You acknowledge and agree that all content available on this website is protected by copyright, trademarks, service marks, patents, trade secrets or other proprietary rights and laws. Except as expressly authorized by Ice Wireless, you agree not to sell, license, rent, modify, distribute, copy, reproduce, transmit, publicly display, publicly perform, publish, adapt, edit, or create derivative works from such materials or content.</p>
                    <p>Notwithstanding the above, you may print or download one copy of the materials or content on this website onto any single computer for personal, non-commercial use, provided that you keep intact all copyright and other proprietary notices. Systematic retrieval of data or other content from this website to create or compile, directly or indirectly, a collection, compilation, database or directory without written permission from Ice Wireless is prohibited. In addition, use of the content or materials for any purpose not expressly permitted in these Terms and Conditions is prohibited.</p>
                    <p>As noted above, reproduction, copying, or redistribution for commercial purposes of any materials or design elements on this website is strictly prohibited without the express written permission of Ice Wireless.</p>
                    <br />
                    <b>12.&nbsp;&nbsp;&nbsp;&nbsp;Additional Phone Numbers</b>
                    <p>You will be assigned a unique account number that will allow one invoice for all Ice Wireless phone numbers. You authorize Ice Wireless to link additional phone numbers to the primary account and agree to be financially liable for all charges by additional phone numbers, including enhanced Services or features.</p>
                    <p>Should the account be terminated for any reason, any additional phone numbers under the account will also be terminated unless an activation request per Ice Wireless pricing in effect at that time is received.</p>
                    <br />
                    <b>13.&nbsp;&nbsp;&nbsp;&nbsp;Roaming</b>
                    <p>Service is available in areas outside the Ice Wireless network that are served by other cellular telephone service providers (“Roaming Partners”) which have partnered with Ice Wireless for the provision of roaming services. Should you leave the Ice Wireless network and use roaming services; you will be liable for all applicable charges levied by our Roaming Partners. For the network coverage and roaming charges please visit www.icewireless.ca. Roaming is not available through Home Phone Services, Home Internet or Multimedia Messaging Services (“MMS”) use.</p>
                    <br />
                    <b>14.&nbsp;&nbsp;&nbsp;&nbsp;Service Outage</b>
                    <p>Services do not function in the event of a power failure. Should there be an interruption in the power supply; Services will not resume until power is restored. A power failure or disruption may require that you reset or reconfigure equipment prior to resuming Services. You acknowledge that the Services or access to the Services, public alerts or special needs Services, may not function correctly, or at all, in the following circumstances:</p>
                    <ul>
                      <li>if your handset fails, is not configured correctly or does not meet Service requirements</li>
                      <li>in the event of a network outage or extended power failure;</li>
                      <li>following suspension or termination of your Services or account;</li>
                      <li>Service interruption as a result of unpaid charges will prevent any calls from being made or received.</li>
                    </ul>
                    <p>If the Service interruption occurred more than 24 hours you may request credit for the portion of recurring charges therein. No credit will be applied in case of Service interruption as a result of improper use of the wireless device, negligence or suspension following unpaid charges.</p>
                    <br />
                    <b>15.&nbsp;&nbsp;&nbsp;&nbsp;Service Limitations</b>
                    <p>The Multimedia Messaging Service (“MMS”) is available to customers electing a Service Plan with data allowance and will operate only through the use of mobile internet. Ice Wireless makes no warranties regarding the successful delivery or receipt of MMS messages, to and from other wireless service providers.</p>
                    <p>We do not currently offer Collect Call or Operator Assistance.</p>
                    <br />
                    <b>16.&nbsp;&nbsp;&nbsp;&nbsp;Fraudulent Calls</b>
                    <p>You are solely responsible for the security and integrity of your Ice Wireless Service and you acknowledge that any usage charges resulting from unauthorized access to your handset by a known or unknown party will be invoiced.</p>
                    <br />
                    <b>17.&nbsp;&nbsp;&nbsp;&nbsp;Hardware</b>
                    <p>You will receive your handset device ready for use in any wireless network, to the extent where technically or as otherwise permitted by another network. You may return the handset for a full refund or exchange it within 15 days of the purchase. One exchange is permitted and a restocking fee may apply. The Ice Wireless handset must be returned in like-new condition, including original manufacturer’s packaging, accessories and the purchase receipt. At our sole discretion, we may decline the return if your cumulated usage exceeds the assigned limits for the Trial Period or charge you for a missing or damaged item.</p>
                    <p>If your wireless device is lost or stolen, you should immediately contact us to suspend the service and protect from unauthorized use. We may determine, in our sole reasonable discretion that your account is being used fraudulently and proceed with suspending the service, but we do not make any warranties or accept liability for the usage charges incurred to date of suspension. We do not charge a fee for suspending or reactivating the service. The monthly charges will continue to be billed on your account for the time of suspension. If you decide to terminate the service, you will be liable for any and all applicable fees incurred to date of termination.</p>
                    <p>Your device purchased from Ice Wireless is subject to manufacturer’s warranty, which is typically valid for one year with your original purchase receipt. If you purchased a new device from Ice Wireless that includes a limited warranty at the time of purchase, you must refer to the limited warranty documentation or access the manufacturer’s website for information on the limitation and disclaimer of certain warranties. If the device did not include a limited warranty at the time of purchase, you agree to accept the unit in question on an “as is” basis and you are not entitled to replacement or refund in the event of any defect. Ice Wireless does not warrant the continuous functioning of all Services or equipment belonging to any third party. The equipment purchased may be delivered with a manufacturer’s warranty and it is understood that the Ice Wireless warranty is in fact limited to the manufacturer’s warranty. Ice Wireless may refuse to activate any equipment that does not comply with Industry Canada’s or its own network requirements.</p>
                    <p>If your device was purchased as part of an Agreement and is under warranty with Ice Wireless or the manufacturer, you may request a free replacement for use during the repair period. If Ice Wireless is unable to provide a replacement and you would otherwise incur a termination fee for cancelling the services, you may request to suspend the monthly service fees until such time as the device is repaired or a Loaner replacement is offered.</p>
                    <br />
                    <b>18.&nbsp;&nbsp;&nbsp;&nbsp;Notices; Changes to the Agreement</b>
                    <p>Notices to Customers shall be considered given on the date sent out by Ice Wireless to the party concerned. You are responsible for notifying us of any changes in your email address by contacting customercare@icewireless.ca. Otherwise, we will continue to use the previous e-mail address until we have received notice of the address change.</p>
                    <p>We may from time to time change Services that are provided to you on a month to month basis by providing [30] days advance notice. We will provide notice by:</p>
                    <ul>
                      <li>Posting the change to www.icewireless.ca. You are required to verify the website regularly for any changes made or announced.</li>
                      <li>Text message to your Ice Wireless phone number.</li>
                      <li>Electronic mail directed to the email address provided upon sign-up for Ice Wireless’s Services, or to the current email address if we received notification that it has changed.</li>
                    </ul>
                    <br />
                    <b>19.&nbsp;&nbsp;&nbsp;&nbsp;Assignment</b>
                    <p>This Agreement may not be assigned in whole or in part by any Party without the prior written consent of the other Party except that Ice Wireless may assign this Agreement without consent to any affiliated entity.</p>
                    <br />
                    <b>20.&nbsp;&nbsp;&nbsp;&nbsp;Limitation of Liability</b>
                    <p>Ice Wireless shall not be liable for any failure to provide its Services or any degradation of quality caused by any of the following:</p>
                    <ul>
                      <li>Act or omission of another carrier used for roaming purposes.</li>
                      <li>Equipment, network or facility failure.</li>
                      <li>Equipment, network or facility upgrade or modification.</li>
                      <li>Equipment, network or facility shortage.</li>
                      <li>Equipment or facility relocation.</li>
                      <li>Force majeure events such as (but not limited to) acts of God, strikes, fire, war, riot, government actions.</li>
                      <li>Any other cause that is beyond Ice Wireless ’s control, including without limitation the failure of an incoming or outgoing call to be connected or completed. This includes degradation of voice quality. Ice Wireless’s liability for any failure or mistake shall in no event exceed service charges on account of the affected time period.</li>
                    </ul>
                    <p>In no event shall Ice Wireless be liable for indirect, consequential or economic loss or damage, including any damages, loss of profit, loss of earnings, financial loss, loss of business opportunities, death, personal injury, defamation or copyright infringement that results from material transmitted or received over the Ice Wireless network, or any other loss however caused, resulting directly or indirectly in connection with these Terms and Conditions or the Services or any equipment, including any 911 calls, or from the use of the Ice Wireless network by other telecommunications carriers. These limits apply to any act or omission of Ice Wireless, its employees or agents, which would otherwise be a cause of action in contract, tort or any other doctrine of law.</p>
                    <p>No credit allowance will be given for interruptions caused by your negligence or by your willful acts, or for service interruption by the failure of your equipment.</p>
                    <br />
                    <b>21.&nbsp;&nbsp;&nbsp;&nbsp;Indemnification</b>
                    <p>The Customer agrees to defend, indemnify, and hold Ice Wireless, its affiliates and agents and any other Service provider who furnish Services to the Customer in connection with this Agreement or Ice Wireless’s Services, free from claims or damages by, or in the right of, the customer relating to this Agreement, Ice Wireless’s Services or the device. This paragraph shall survive termination of this Agreement.</p>
                    <br />
                    <b>22.&nbsp;&nbsp;&nbsp;&nbsp;No Warranties on Service</b>
                    <p>ICE WIRELESS, ITS AFFILIATES, DIRECTORS, EMPLOYEES AND AGENTS PROVIDE THE SERVICES “AS-IS” AND MAKE NO EXPRESS OR IMPLIED WARRANTIES OF ANY KIND IN CONNECTION WITH THE NETWORK, THE SERVICES (INCLUDING ANY FEATURES) OR THE EQUIPMENT CONTEMPLATED HEREIN, WHETHER WRITTEN OR ORAL, STATUTORY, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE WARRANTY OF MERCHANTABILITY AND THE WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE OR USE. ALL REPRESENTATIONS WARRANTIES OR CONDITIONS OF ANY KIND ARE, TO THE EXTENT PERMITTED BY APPLICABLE LAW, HEREBY EXCLUDED.</p>
                    <br />
                    <b>23.&nbsp;&nbsp;&nbsp;&nbsp;Confidential Information</b>
                    <p>Confidential Information shall include all data, materials, products, technology, computer programs, specifications, manuals, business plans, software, marketing plans, financial information, and other information disclosed or submitted, orally, in writing, or by any other media, by Ice Wireless to the Customer that has not been made publicly available.</p>
                    <p>Except as otherwise specified herein, the Customer and Ice Wireless each expressly undertake to retain in confidence all information transmitted to them by the other party pursuant to this Agreement that the disclosing party identifies as being proprietary and/or confidential or that, by the nature of the circumstances surrounding the disclosure, ought in good faith to be treated as proprietary and/or confidential (“Confidential Information”), and will make no use of such Confidential Information except under the terms and during the existence of this Agreement.</p>
                    <p>The Customer and Ice Wireless shall treat the terms and conditions of their Service Agreement as confidential; however, either party may disclose such information in confidence to its immediate legal and financial consultants as required in the ordinary course of that party’s business.</p>
                    <p>The receiving party’s obligation hereunder shall extend for two (2) years following the disclosure of the Confidential Information.</p>
                    <p>Unless the Customer consents in writing or disclosure is pursuant to a legal power, all information kept by Ice Wireless, other than the Customer’s name and address, is considered confidential and will not be released to anyone, with the following exceptions:</p>
                    <ul>
                      <li>The Customer or his representative by law</li>
                      <li>Another telecommunications carrier (Local Number Portability) or other person(s) providing Services to a telecommunications carrier, provided that the information is to be used for the establishment of, or the efficient and cost-effective provision of wireless telephone Service. Disclosure is made on a confidential basis, with the information to be used solely for the indicated purpose</li>
                      <li>An agent retained by Ice Wireless to collect outstanding balances owed by the Customer, or companies performing other administrative functions for Ice Wireless, provided that the information is released solely for the indicated purposes</li>
                      <li>At the Customer’s request, to a third-party company providing directory listing Services, provided that the disclosure of information other than name, address and listed telephone number is made on a confidential basis, with the information to be used solely for the indicated purpose</li>
                      <li>To law enforcement agency, whenever we have reasonable grounds to believe that the Customer has knowingly supplied Ice Wireless with false or misleading information or are otherwise involved in unlawful activities directed against Ice Wireless. Upon request, the Customer may inspect any of the Ice Wireless records related to his Service.</li>
                      <li>A public authority or its agent if Ice Wireless reasonably believes that there is imminent danger to life or property that could be avoided or minimized by disclosure of the information.</li>
                    </ul>
                    <p>Ice Wireless does not guarantee the privacy of any communications while using the Ice Wireless Service or equipment.</p>
                    <br />
                    <b>24.&nbsp;&nbsp;&nbsp;&nbsp;Privacy Policy</b>
                    <p>Ice Wireless regards its Customer’s privacy as one of its most important values and believes that its Privacy Policy will give the Customer confidence whenever they use Ice Wireless Services. Ice Wireless is not liable for any lack of privacy which may be experienced by any Customer with regard to the use of the Services or any equipment.</p>
                    <p>Ice Wireless collects personal information to:</p>
                    <ul>
                      <li>Prevent fraud and protect itself and its Customers from possible fraudulent actions</li>
                      <li>Help provide the Customer with better Service delivery</li>
                      <li>Understand each Customer’s needs in order to recommend appropriate products or Services</li>
                      <li>Better manage its own operations</li>
                      <li>Comply with legislative requirements</li>
                      <li>Evaluate your creditworthiness</li>
                      <li>Develop, enhance, market or provide products and services</li>
                    </ul>
                    <p>The Customer’s knowledge and consent to the collection, use or disclosure of personal information is required, except where inappropriate to do so. Ice Wireless will limit its collection of personal information to that which is necessary for the above-mentioned purposes. This collection shall only be done by fair and lawful means. Ice Wireless will not use or disclose personal information for any purposes other than those for which it was collected, except with the consent of the individual or as required by law.</p>
                    <p>The Personal information shall be as accurate, complete, and up-to-date as is necessary for its stated purpose. Upon request, the Customer shall be informed of the existence, use, and disclosure of his or her personal information and shall be given access to that information. The Customer may challenge the accuracy and completeness of the information and have it amended as appropriate.</p>
                    <p>When we provide information to third parties, such parties are required to adhere to confidentiality agreements to ensure that the Customer’s information remains safe and secure. Third parties include Ice Wireless agents, other communication Service provider, collection agencies, government agencies, emergency Services and law enforcement agencies, or other companies assisting us in fraud prevention or investigation. The information is not provided to other companies for marketing purposes. Personal information may be disclosed when:</p>
                    <ul>
                      <li>Trying to protect against or prevent actual or potential fraud or unauthorized transactions</li>
                      <li>Investigating fraud which has already taken place.</li>
                    </ul>
                    <p>Your personal identifiable information is kept secure. Only authorized employees, agents and contractors who have agreed to keep information secure and confidential have access to this information. Personal information shall be retained only as long as necessary for the fulfillment of its stated purpose.</p>
                    <p>During the registration process you will be required to choose a password that will be asked by one of our Customer Care representatives any time you will request information about your account or any type of changes. You are fully responsible for the confidentiality of your credentials and for any actions on your account. Any unauthorized use of your credentials or any breach of security must be reported immediately to Ice Wireless.</p>
                    <p>“Personal Information” means information about an identifiable individual and includes Ice Wireless Customer Service selection information; however, such information may be disclosed in confidence to its immediate legal and /or financial consultants as required.</p>
                    <p>Information that is publicly available (such as a public directory listing of a name or information that is printed on a business card – including the Customer’s address, telephone number and email address) is not considered personal information.</p>
                    <p>Ice Wireless is committed to privacy and the protection of personal information used in the course of providing programs and Services. Ice Wireless Inc. and its respective offices are subject to the Privacy Act. In addition, the Personal Information Protection and Electronic Documents Act and equivalent provincial/ territorial legislation extend privacy protection to govern the manner in which personal information is managed. If you have any questions, concerns, or comments about our privacy policy, you may contact us using security@icewireless.ca.</p>
                    <br />
                    <b>25.&nbsp;&nbsp;&nbsp;&nbsp;Marketing Communication</b>
                    <p>Unless you decline to receive communications from Ice Wireless or withdraw your consent at a later date, you agree that Ice Wireless may send you communications by any means (including electronically or by phone) to inform you of new offers and promotions. You may contact the Ice Wireless Customer Care Team to change your communication options or withdraw consent.</p>
                    <br />
                    <b>26.&nbsp;&nbsp;&nbsp;&nbsp;Resolution of Disputes</b>
                    <p>Mandatory Arbitration: Any dispute or claim between a Customer and Ice Wireless arising out of, or relating to, Ice Wireless’s Services or devices provided by Ice Wireless in connection with this Agreement shall be resolved by arbitration before a single arbitrator according to the applicable laws of the province in which the Customer resides. The arbitrator’s decision shall follow the plain meaning of the relevant documents and shall be final and binding.</p>
                    <p>Without limiting the foregoing, the parties agree that no arbitrator has the authority to: (i) award relief in excess of what this Agreement provides; or (ii) award punitive or exemplary damages. Judgment on the award rendered by the arbitrators may be entered in any court having jurisdiction thereof.</p>
                    <p>All claims shall be arbitrated individually and the Customer will not bring, or join a punitive or certified class action to arbitration or seek to consolidate or bring previously consolidated claims to the arbitration process. The arbitrator shall have no authority to award punitive damages. The Customer acknowledges that this arbitration provision constitutes a waiver of any right to a jury trial. However, if the dispute relates to a matter that should be brought before the Canadian Radio Television and Telecommunications Commission (CRTC) you agree that the CRTC will resolve the dispute.</p>
                    <p>If a dispute has not been resolved to your satisfaction by the Ice Wireless Team, you may contact the Commissioner for Complaints for Telecommunications Services (CCTS): P.O. Box 81088 Ottawa, Ontario, K1P 1B1. Toll-free: 1-888-221-1687. TTY: 1-877-782-2384. Fax: 1-877-782-2924. Email: response@ccts-cprst.ca. Website: www.ccts-cprst.ca.</p>
                    <br />
                    <b>27.&nbsp;&nbsp;&nbsp;&nbsp;Governing Law</b>
                    <p>This Agreement shall be governed by and construed in accordance with the laws of Ontario and the applicable laws of Canada, without regard to its conflict of law provisions. The Customer and Ice Wireless agree to submit to the personal and exclusive jurisdiction of the courts located within the Province of Ontario. The failure of Ice Wireless to exercise or enforce any right or provision of the Agreement shall not constitute a waiver of such right or provision. The Customer agrees that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of Ice Wireless’s Services or the Agreement must be filed within one (1) year after such claim or cause of action arose or be forever barred.</p>
                    <br />
                    <b>28.&nbsp;&nbsp;&nbsp;&nbsp;Severability</b>
                    <p>If any part of this Agreement is legally declared invalid or unenforceable, all other parts of this Agreement are still valid and enforceable. Such invalidity or non-enforceability will not invalidate or render unenforceable any other portion of this Agreement. If any provision of the Agreement is found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavor to give effect to the parties’ intentions as reflected in the provision, and the other provisions of the Agreement remain in full force and effect.</p>
                    <p>
                      <b>YOUR RIGHTS AS A WIRELESS CONSUMER:</b>
                      <a
                        href="http://www.crtc.gc.ca/eng/info_sht/t15.htm"
                      >http://www.crtc.gc.ca/eng/info_sht/t15.htm</a>
                    </p>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn color="primary darken-1" flat @click.native="dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout class="layout-stepper" row v-show="!!process">
            <v-flex xs12>
              <div>
                <h3 id="stepTitle" class="process-label" ref="stepTitle">Waiting to process...</h3>
                <v-stepper v-model="steps">
                  <v-stepper-header>
                    <v-stepper-step :rules="[rules.isStep1Error]" :complete="steps >= 1" step="1"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep2Error]" :complete="steps >= 2" step="2"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep3Error]" :complete="steps >= 3" step="3"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep4Error]" :complete="steps >= 4" step="4"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep5Error]" :complete="steps >= 5" step="5"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep6Error]" :complete="steps >= 6" step="6"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep7Error]" :complete="steps >= 7" step="7"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep8Error]" :complete="steps >= 8" step="8"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :rules="[rules.isStep9Error]" :complete="steps >= 9" step="9"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      :rules="[rules.isStep10Error]"
                      :complete="steps >= 10"
                      step="10"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      :rules="[rules.isStep11Error]"
                      :complete="steps === 11"
                      step="11"
                    ></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items></v-stepper-items>
                </v-stepper>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="alertMessage">
            <v-flex xs12>
              <app-alert
                @dismissed="dismiss"
                :text="alertMessage"
                :link="alertLink"
                :link_text="alertLinkText"
              ></app-alert>
            </v-flex>
          </v-layout>
          <v-layout row wrap pa-1>
            <v-flex xs6 class="text-xs-left">
              <v-btn
                @click="goBack"
                class="ml-0"
                outline
                color="secondary"
                :disabled="loading === true || !!alertMessage && this.steps > 2"
              >&laquo; Back</v-btn>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn
                @click="submit"
                class="mr-0"
                outline
                color="primary"
                :loading="loading"
                :disabled="loading === true || valid === false || accepted === false || !!alertMessage && this.steps > 2"
              >Finish &raquo;</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// ref: https://gist.github.com/ShirtlessKirk/2134376
var luhnChk = (function(arr) {
  return function(ccNum) {
    if (!ccNum) {
      return;
    }

    var len = ccNum.length;
    var bit = 1;
    var sum = 0;
    var val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

export default {
  data() {
    return {
      alertMessage: null,
      alertLink: null,
      alertLinkText: null,
      valid: true,
      failedAVS: false,
      failedCVD: false,
      numberTaken: false,
      updateBillingDetails: false,
      planDescription:
        "<span>Unlimited local calling</span><span>Unlimited local text</span><span>1GB data</span>",
      topup: false,
      accepted: false,
      dialog: false,
      process: false,
      issueNumber:
        new Date()
          .getTime()
          .toString(36)
          .toUpperCase() +
        Math.random()
          .toString()
          .slice(2, 9),
      steps: 0,
      stepError: 0,
      stepTitles: [
        "Verifying Telephone Number",
        "Verifying Plan",
        "Processing Payment",
        "Updating Master Account",
        "Creating Service Account",
        "Recording Payment",
        "Updating Service Account",
        "Assigning Telephone Number",
        "Assigning SIM",
        "Setting up Automatic Payments",
        "Sending Confirmation"
      ],
      provinces: [
        { name: "Alberta", val: "AB" },
        { name: "British Columbia", val: "BC" },
        { name: "Manitoba", val: "MB" },
        { name: "New Brunswick", val: "NB" },
        { name: "Newfoundland & Labrador", val: "NL" },
        { name: "Nova Scotia", val: "NS" },
        { name: "Ontario", val: "ON" },
        { name: "Prince Edward Island", val: "PEI" },
        { name: "Quebec", val: "QC" },
        { name: "Saskatchewan", val: "SK" },
        { name: "Northwest Territories", val: "NT" },
        { name: "Nunavut", val: "NU" },
        { name: "Yukon", val: "YT" }
      ],
      cc: {
        name: null,
        number: null,
        expiryMonth: null,
        expiryYear: null,
        cvc: null,
        type: null,
        billingAddress1: null,
        billingAddress2: null,
        billingAddress3: null,
        billingAddressCity: null,
        billingAddressProvince: null,
        billingAddressPostalCode: null
      },
      rules: {
        required: value => {
          return !!value || "Required";
        },
        validCreditCard: v => {
          return luhnChk(v) || "Please enter a valid credit card number.";
        },
        validCreditCardType: v => {
          return (
            !!this.getCreditCardType(v) ||
            "Supported Credit Cards: VISA, MASTERCARD or AMEX"
          );
        },
        expiryYear: v => {
          var currentYear = new Date().getFullYear();
          return v >= currentYear || "Please enter a valid expiry year.";
        },
        streetAddress: v => {
          let result = /(.?\d{1,}.?\d{0,})\s([a-zA-Z]{1,30}\s.+)/.exec(v);
          return (result && result.length === 3) || "Enter a valid address";
        },
        email: v => {
          if (this.brand.rules.email) {
            return this.brand.rules.email(v);
          } else {
            return (
              /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
              "E-mail must be valid"
            );
          }
        },
        postalCode: v => {
          return (
            /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/.test(v) ||
            "Invalid postal code"
          );
        },
        matches: () => {
          return this.passwordsMatch || "Password's must match.";
        },
        securePassword: () => {
          return this.isSecure() || "Password needs to be stronger.";
        },
        isStep1Error: () => {
          return !(this.stepError !== 0 && this.steps < 1);
        },
        isStep2Error: () => {
          return !(this.stepError === 1 && this.steps < 2);
        },
        isStep3Error: () => {
          return !(this.stepError === 2 && this.steps < 3);
        },
        isStep4Error: () => {
          return !(this.stepError === 3 && this.steps < 4);
        },
        isStep5Error: () => {
          return !(this.stepError === 4 && this.steps < 5);
        },
        isStep6Error: () => {
          return !(this.stepError === 5 && this.steps < 6);
        },
        isStep7Error: () => {
          return !(this.stepError === 6 && this.steps < 7);
        },
        isStep8Error: () => {
          return !(this.stepError === 7 && this.steps < 8);
        },
        isStep9Error: () => {
          return !(this.stepError === 8 && this.steps < 9);
        },
        isStep10Error: () => {
          return !(this.stepError === 9 && this.steps < 10);
        },
        isStep11Error: () => {
          return !(this.stepError === 10 && this.steps < 11);
        }
      },
      masks: {
        creditCard: "credit-card",
        expiryMonth: "##",
        expiryYear: "####",
        cvc: "####"
      }
    };
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
    planName() {
      return this.$store.getters.selectedPlan.planType;
    },
    planPhone() {
      return this.$store.getters.selectedPhone.phoneNumber;
    },
    planPrice() {
      return this.$store.getters.selectedPlan.recurringCharge;
    },
    taxes() {
      return this.planPrice * this.taxRate;
    },
    taxRate() {
      return this.$store.getters.taxRate;
    },
    subtotal() {
      return this.planPrice;
    },
    totalPrice() {
      return this.planPrice + this.planPrice * this.taxRate;
    },
    isFinished() {
      return this.$store.getters.isFinished;
    }
  },
  watch: {
    error(val) {
      if (!val) {
        this.alertMessage = null;
        this.failedAVS = false;
        this.failedCVD = false;
        this.numberTaken = false;
        return;
      }

      var status = (val && val.response && val.response.status) || 500;
      if (status > 404) {
        status = 500;
      }
      switch (status) {
        case 400:
        case 401:
        case 403:
        case 404:
          if (val.response.data && val.response.data.error) {
            switch (parseInt(val.response.data.error.code)) {
              case 18:
                this.numberTaken = true;
                this.alertMessage = `Error reserving number <b>${this.$options.filters.phone(
                  this.planPhone
                )}</b>. 
                    It may have already been reserved by another user.</p>`;
                this.alertLink = { name: "select-number" };
                this.alertLinkText = "Choose another number";
                break;

              // case 481:
              //   this.failedAVS = true;
              //   break;

              default:
                if (!!val.response.data.error.failedAVS) {
                  this.failedAVS = true;
                }
                if (!!val.response.data.error.failedCVD) {
                  this.failedCVD = true;
                }
                this.alertMessage = `<p>An error occurred processing your order:  ${
                  this.steps === 2
                    ? "Payment Declined. " + (val.response.data.error.iso === "51" ? "Insufficient Funds." : val.response.data.error.code === "475" && val.response.data.error.iso === "06" ? "Check Card Expiry." : this.failedCVD ? "Verify CVV." : "Verify payment details.") + "<br/><br/>OR"
                    : "<em>Code" + val.response.data.error.code + ".</em>"
                }</p><p>Please Contact support at <a href="tel:185554747423">1 (855) 474-7423</a> or <a href="mailto:customercare@icewireless.com">customercare@icewireless.com</a> for more information with the following Issue <strong>#${
                  this.issueNumber
                }</strong>.</p>`;
                break;
            }
          }
          break;
        case 500:
          this.alertMessage = `${
            this.steps === 2
              ? "Payment Declined.  Verify payment details.<br/><br/>OR"
              : "Oops, Something went wrong."
          } Please contact support at <a href="tel:185554747423">1 (855) 474-7423</a> or <a href="mailto:customercare@icewireless.com">customercare@icewireless.com</a> for more information with the following Issue <strong>#${
            this.issueNumber
          }</strong>.`;
          break;
      }
    },
    isFinished(val) {
      if (val === true) {
        this.$router.push({ name: "thank-you" });
      }
    }
  },
  methods: {
    getCreditCardType(card) {
      if (!card) {
        return false;
      }

      // visa
      let re = new RegExp("^4");
      if (card.match(re) != null) {
        return "VISA";
      }

      // Mastercard
      // Updated for Mastercard 2017 BINs expansion
      if (
        /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
          card
        )
      ) {
        return "MASTERCARD";
      }

      // AMEX
      re = new RegExp("^3[47]");
      if (card.match(re) != null) {
        return "AMEX";
      }

      // Discover
      // re = new RegExp(
      //   "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
      // );
      // if (card.match(re) != null) return "Discover";

      // Diners
      // re = new RegExp("^36");
      // if (card.match(re) != null) return "Diners";

      // Diners - Carte Blanche
      // re = new RegExp("^30[0-5]");
      // if (card.match(re) != null) return "Diners - Carte Blanche";

      // JCB
      // re = new RegExp("^35(2[89]|[3-8][0-9])");
      // if (card.match(re) != null) return "JCB";

      // Visa Electron
      // re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      // if (card.match(re) != null) return "Visa Electron";
      return false;
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },

    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.dismiss();
        // await this.$store.dispatch("setLoading");
        this.process = true;

        let user = this.$store.getters.user.contact;
        let amount = null;
        let plan = null;
        let reference = null;
        let serviceId = null;
        this.cc.type = this.getCreditCardType(this.cc.number);
        if (this.failedAVS) {
          user = {
            ...this.$store.getters.user.contact,
            address1: this.cc.billingAddress1,
            address2: this.cc.billingAddress2,
            address3: this.cc.billingAddress3,
            city: this.cc.billingAddressCity,
            province: this.cc.billingAddressProvince,
            country: "CA",
            postalCode: this.cc.billingAddressPostalCode
          };
        }
        var stepTitle = this.$refs.stepTitle;
        this.steps = 0;
        this.stepError = 0;
        this.process = true;
        try {
          stepTitle.innerText = this.stepTitles[this.steps];
          await this.$store.dispatch("processOrderVerifyTelephoneNumber", {
            contact: user
          });
          stepTitle.innerText = this.stepTitles[++this.steps];
          ({ amount, plan } = await this.$store.dispatch(
            "processOrderVerifyPlan",
            {
              contact: user
            }
          ));
          stepTitle.innerText = this.stepTitles[++this.steps];
          reference = await this.$store.dispatch("processOrderProcessPayment", {
            contact: user,
            amount,
            creditCard: {
              number: this.cc.number,
              holder: this.cc.name,
              expMonth: this.cc.expiryMonth,
              expYear: this.cc.expiryYear,
              CVV: this.cc.cvc,
              type: this.cc.type
            }
          });
          stepTitle.innerText = this.stepTitles[++this.steps];
          if (this.updateBillingDetails) {
            await this.$store.dispatch("processOrderUpdateMasterAccount", {
              contact: user
            });
          }
          await this.timeout(2000);
          stepTitle.innerText = this.stepTitles[++this.steps];
          serviceId = await this.$store.dispatch(
            "processOrderCreateServiceAccount",
            {
              contact: user
            }
          );
          await this.timeout(2000);
          stepTitle.innerText = this.stepTitles[++this.steps];
          await this.$store.dispatch("processOrderRecordPayment", {
            contact: user,
            serviceId,
            reference,
            amount
          });
          await this.timeout(2000);
          stepTitle.innerText = this.stepTitles[++this.steps];
          await this.$store.dispatch("processOrderUpdateServiceAccount", {
            serviceId
          });
          await this.timeout(2000);
          stepTitle.innerText = this.stepTitles[++this.steps];
          await this.$store.dispatch("processOrderAssignTelephoneNumber", {
            contact: user,
            serviceId
          });
          await this.timeout(2000);
          stepTitle.innerText = this.stepTitles[++this.steps];
          await this.$store.dispatch("processOrderAssignSIM", {
            contact: user,
            serviceId
          });
          stepTitle.innerText = this.stepTitles[++this.steps];
          if (this.topup) {
            await this.$store.dispatch("processOrderSetupAutomaticPayments", {
              amount,
              serviceId,
              contact: user,
              creditCard: {
                number: this.cc.number,
                holder: this.cc.name,
                expMonth: this.cc.expiryMonth,
                expYear: this.cc.expiryYear,
                CVV: this.cc.cvc,
                type: this.cc.type
              }
            });
          }
          stepTitle.innerText = this.stepTitles[++this.steps];
          await this.timeout(2000);
          await this.$store.dispatch("processOrderSendConfirmation", {
            serviceId,
            contact: user,
            plan
          });
          ++this.steps;
          await this.$store.dispatch("completeOrder");
        } catch (error) {
          this.stepError = this.steps;
          if (this.failedAVS) {
            return;
          }
          let missingSteps = Array.from(this.stepTitles);
          missingSteps = missingSteps.slice(this.stepError);
          if (!this.topup) {
            missingSteps.splice(-2, 1);
          }
          let creditCard = Object.assign({}, this.cc);
          creditCard.number = creditCard.number.replace(/\d(?=\d{4})/g, "*");
          await this.$store.dispatch("logOrderError", {
            error,
            issueNumber: this.issueNumber,
            missingSteps,
            data: {
              serviceId,
              contact: user,
              reference,
              amount,
              creditCard,
              plan
            }
          });
          await this.$store.dispatch("clearDetails");
        }
      } else {
        console.log("invalid form...");
      }
    },
    dismiss() {
      this.$store.dispatch("clearError");
      this.alertMessage = null;
    }
  }
};
</script>

<style lang="scss" scoped>
hr.divider {
  background-color: rgb(211, 211, 211);
}

.alt--row {
  padding: 8px 0;
  margin-top: 8px;
}

.bg--stripe {
  background: #f9f9f9;
}

.product--desc {
  padding: 15px;
  margin: 8px 0;
  border-right: 1px solid #ddd;
}

.product--line-item-price {
  padding: 16px 0;
}

.plan--desc {
  text-transform: none;

  & /deep/ span {
    display: block;
    padding: 2px 0;
  }
}

.details--whats-included {
  background: #e9f2f6;
  padding: 16px;
  margin: 8px 0;
}

.plan--costs {
  background: #f9f9f9;
}

.price--total {
  font-weight: bold;
  font-size: 14px;

  @media (min-width: 600px) {
    font-size: 20px;
  }
}

.billing-details-extra {
  background: #efefef;
  padding: 5px 15px !important;
  border: 1px solid #ddd;
  border-width: 1px 0;
  margin: 5px 0;
}

.billing-details {
  transition: background 0.3s ease-in;
}

.billing-details-warning {
  background: #feffd4;
}

.terms {
  max-height: 350px;
  overflow: scroll;
  padding: 8px;
}

.conditions {
  & h1 {
    color: #105079;
    margin: 20px 0;
  }
  & ul {
    margin-left: 30px;
  }
  & b {
    letter-spacing: 1px;
    color: #363636;
  }
}

.nowrap {
  & /deep/ label {
    height: auto;
    white-space: normal;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.snack.error a {
  color: #fff;
}

.layout-stepper {
  padding-bottom: 30px;
}

.process-label {
  color: rgba(0, 0, 0, 0.54);
}
</style>


// WEBPACK FOOTER //
// src/components/billing/BillingDetails.vue